// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7ec60dbc","732":"29e272ea","977":"f3912843"}[chunkId] + ".chunk.js";
};